module.exports = __webpack_public_path__ + "img/krisma.c59bb6e5.jpg";